import { render } from "./AssetsDisposition.vue?vue&type=template&id=46464d87&scoped=true"
import script from "./AssetsDisposition.vue?vue&type=script&lang=js"
export * from "./AssetsDisposition.vue?vue&type=script&lang=js"

import "./AssetsDisposition.vue?vue&type=style&index=0&id=46464d87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46464d87"]])

export default __exports__